














 
















































































































































































































































































































































































































































































































































































































































































































const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelledAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledEndTime",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UpdateRecurrenceSettingsSuccess",
  "kind": "LinkedField",
  "name": "UpdateRecurrenceSettingsSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPromptMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingSeriesId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingSeries",
          "kind": "LinkedField",
          "name": "meetingSeries",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ServiceField",
  "kind": "LinkedField",
  "name": "serviceField",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PokerMeeting",
    "kind": "LinkedField",
    "name": "meeting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phases",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stages",
                "plural": true,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "EstimatePhase",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLead",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNotRemoved",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v18 = [
  (v1/*: any*/),
  (v7/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v22 = [
  (v1/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "AgendaItem",
  "kind": "LinkedField",
  "name": "agendaItem",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMember",
      "kind": "LinkedField",
      "name": "teamMember",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorStageId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseType",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigable",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endedAt",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorUserId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigableByFacilitator",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "phases",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UpdatesStage",
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v27/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UpdatesPhase",
  "abstractKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discussionId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupColor",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v38 = [
  (v1/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "activeMeetings",
  "plural": true,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v7/*: any*/),
    (v39/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamTemplateIds",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "DenyPushInvitationPayload",
  "kind": "LinkedField",
  "name": "DenyPushInvitationPayload",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isKill",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskCount",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "ActionMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v28/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agendaItemCount",
      "storageKey": null
    },
    (v44/*: any*/),
    (v45/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedTaskIds",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "AgendaItem",
  "kind": "LinkedField",
  "name": "agendaItems",
  "plural": true,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v39/*: any*/),
    (v48/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "timelineEvent",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v50/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingId",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "updatedTasks",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    (v15/*: any*/),
    (v33/*: any*/),
    (v52/*: any*/),
    (v53/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reflectionCount",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topicCount",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "AutogroupReflectionGroup",
  "kind": "LinkedField",
  "name": "autogroupReflectionGroups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupTitle",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v58 = [
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "voteCount"
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroReflection",
  "kind": "LinkedField",
  "name": "reflections",
  "plural": true,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recallBotId",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoMeetingURL",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v39/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "PokerMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v28/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamPromptMeetingStatus_meeting"
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emptyReflectionGroupIds",
  "storageKey": null
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RetroDiscussStage",
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        (v30/*: any*/),
        (v52/*: any*/),
        (v25/*: any*/),
        (v33/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RetroReflectionGroup",
          "kind": "LinkedField",
          "name": "reflectionGroup",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "voteCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v21/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "DiscussPhase",
  "abstractKey": null
},
v68 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DashboardAvatar_teamMember"
  },
  (v11/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "PushInvitationPayload",
  "kind": "LinkedField",
  "name": "PushInvitationPayload",
  "plural": false,
  "selections": [
    (v52/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v14/*: any*/),
        (v69/*: any*/)
      ],
      "storageKey": null
    },
    (v50/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "AgendaItem",
  "kind": "LinkedField",
  "name": "agendaItem",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMembers",
  "plural": true,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "meetingMembers",
  "plural": true,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readyCount",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "phases",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v75/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v77 = [
  (v1/*: any*/),
  (v15/*: any*/)
],
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "ReflectTemplate",
  "kind": "LinkedField",
  "name": "reflectTemplate",
  "plural": false,
  "selections": (v77/*: any*/),
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedTemplateId",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "ReflectTemplate",
  "kind": "LinkedField",
  "name": "selectedTemplate",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v81 = [
  (v79/*: any*/),
  (v80/*: any*/)
],
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "RemoveReflectTemplatePromptPayload",
  "kind": "LinkedField",
  "name": "RemoveReflectTemplatePromptPayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReflectPrompt",
      "kind": "LinkedField",
      "name": "prompt",
      "plural": false,
      "selections": (v77/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "updatedTasks",
  "plural": true,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMember",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v85 = [
  (v7/*: any*/)
],
v86 = {
  "kind": "InlineFragment",
  "selections": (v81/*: any*/),
  "type": "RetrospectiveMeetingSettings",
  "abstractKey": null
},
v87 = {
  "kind": "InlineFragment",
  "selections": [
    (v79/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PokerTemplate",
      "kind": "LinkedField",
      "name": "selectedTemplate",
      "plural": false,
      "selections": (v38/*: any*/),
      "storageKey": null
    }
  ],
  "type": "PokerMeetingSettings",
  "abstractKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAtURLs",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "SetAppLocationSuccess",
  "kind": "LinkedField",
  "name": "SetAppLocationSuccess",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v88/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseTypes",
  "storageKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableAnonymity",
      "storageKey": null
    },
    (v62/*: any*/)
  ],
  "type": "RetrospectiveMeetingSettings",
  "abstractKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "ActionMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v95 = [
  (v14/*: any*/)
],
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "activeMeetings",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingCard_meeting"
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "useSnacksForNewMeetings_meetings",
          "selections": [
            (v1/*: any*/),
            (v93/*: any*/),
            (v94/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "createdByUser",
              "plural": false,
              "selections": (v95/*: any*/),
              "storageKey": null
            },
            (v7/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": ([]/*: any*/)
        },
        (v1/*: any*/),
        (v15/*: any*/),
        (v7/*: any*/),
        (v93/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "meetingMembers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                (v88/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MeetingSeries",
              "kind": "LinkedField",
              "name": "meetingSeries",
              "plural": false,
              "selections": [
                (v93/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TeamPromptMeeting",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "RetrospectiveMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "PokerMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "UpdateAgendaItemPayload",
  "kind": "LinkedField",
  "name": "UpdateAgendaItemPayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgendaItem",
      "kind": "LinkedField",
      "name": "agendaItem",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v15/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    },
    (v52/*: any*/)
  ],
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPaid",
  "storageKey": null
},
v101 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Team",
    "kind": "LinkedField",
    "name": "teamsUpdated",
    "plural": true,
    "selections": [
      (v100/*: any*/),
      (v53/*: any*/)
    ],
    "storageKey": null
  }
],
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tier",
  "storageKey": null
},
v104 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Team",
    "kind": "LinkedField",
    "name": "teams",
    "plural": true,
    "selections": [
      (v100/*: any*/),
      (v103/*: any*/)
    ],
    "storageKey": null
  }
],
v105 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webhookUrl",
      "storageKey": null
    }
  ],
  "type": "IntegrationProviderWebhook",
  "abstractKey": null
},
v106 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serverBaseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tenantId",
      "storageKey": null
    }
  ],
  "type": "IntegrationProviderOAuth2",
  "abstractKey": null
},
v107 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "provider",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v105/*: any*/),
      (v106/*: any*/)
    ],
    "storageKey": null
  }
],
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v109 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PokerMeeting",
    "kind": "LinkedField",
    "name": "meeting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phases",
        "plural": true,
        "selections": [
          (v108/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EstimateStage",
                "kind": "LinkedField",
                "name": "stages",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "EstimatePhase",
            "abstractKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateScaleValue",
  "kind": "LinkedField",
  "name": "values",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v110/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedAt",
  "storageKey": null
},
v114 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeeting"
},
v115 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v1/*: any*/)
],
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMember",
  "plural": false,
  "selections": (v115/*: any*/),
  "storageKey": null
},
v117 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNewMeetingPhase"
},
v118 = [
  (v7/*: any*/),
  (v1/*: any*/)
],
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgId",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isStarter",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateScaleValue",
  "kind": "LinkedField",
  "name": "values",
  "plural": true,
  "selections": [
    (v110/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSelf",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAt",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingType",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "phases",
  "plural": true,
  "selections": [
    (v108/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "stages",
      "plural": true,
      "selections": [
        (v108/*: any*/),
        (v26/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v126 = [
  (v14/*: any*/),
  (v1/*: any*/)
],
v127 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "activeMeetings",
  "plural": true,
  "selections": [
    (v108/*: any*/),
    (v114/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "meetingMembers",
      "plural": true,
      "selections": [
        (v108/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v17/*: any*/),
            (v123/*: any*/),
            (v88/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v7/*: any*/),
    (v124/*: any*/),
    (v125/*: any*/),
    (v50/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingSeries",
          "kind": "LinkedField",
          "name": "meetingSeries",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v4/*: any*/),
            (v3/*: any*/),
            (v93/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TeamPromptMeeting",
      "abstractKey": null
    },
    (v93/*: any*/),
    (v94/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdByUser",
      "plural": false,
      "selections": (v126/*: any*/),
      "storageKey": null
    },
    (v15/*: any*/)
  ],
  "storageKey": null
},
v128 = {
  "kind": "InlineFragment",
  "selections": [
    (v93/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Notification",
  "abstractKey": "__isNotification"
},
v129 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v118/*: any*/),
  "storageKey": null
},
v130 = [
  (v108/*: any*/),
  (v1/*: any*/)
],
v131 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "activeMeetings",
  "plural": true,
  "selections": (v130/*: any*/),
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v7/*: any*/),
    (v131/*: any*/)
  ],
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v131/*: any*/),
    (v48/*: any*/)
  ],
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "timelineEvent",
  "plural": false,
  "selections": [
    (v108/*: any*/),
    (v1/*: any*/),
    (v50/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v131/*: any*/)
  ],
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "activeMeetings",
  "plural": true,
  "selections": [
    (v108/*: any*/),
    (v1/*: any*/),
    (v93/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "concreteType": "Reactji",
  "kind": "LinkedField",
  "name": "reactjis",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isViewerReactji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "users",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v138 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localStageId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRightDrawerOpen",
      "storageKey": null
    }
  ]
},
v139 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v140 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "localStage",
  "plural": false,
  "selections": (v130/*: any*/),
  "storageKey": null
},
v141 = [
  (v122/*: any*/),
  (v14/*: any*/),
  (v16/*: any*/),
  (v11/*: any*/),
  {
    "alias": "teamMemberId",
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  (v15/*: any*/),
  (v1/*: any*/),
  (v13/*: any*/),
  (v112/*: any*/)
],
v142 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "activeMeetings",
    "plural": true,
    "selections": [
      (v108/*: any*/),
      (v24/*: any*/),
      (v29/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "meetingMembers",
        "plural": true,
        "selections": (v130/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phases",
        "plural": true,
        "selections": [
          (v108/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "stages",
            "plural": true,
            "selections": [
              (v108/*: any*/),
              (v1/*: any*/),
              (v75/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v143 = [
  (v108/*: any*/),
  (v7/*: any*/),
  (v1/*: any*/)
],
v144 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v127/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v145 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Team",
    "kind": "LinkedField",
    "name": "teamsUpdated",
    "plural": true,
    "selections": [
      (v100/*: any*/),
      (v53/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v146 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Team",
    "kind": "LinkedField",
    "name": "teams",
    "plural": true,
    "selections": [
      (v100/*: any*/),
      (v103/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v147 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "provider",
    "plural": false,
    "selections": [
      (v108/*: any*/),
      (v1/*: any*/),
      (v105/*: any*/),
      (v106/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TeamSubscriptionPayload",
        "kind": "LinkedField",
        "name": "teamSubscription",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateDimensionFieldSuccess",
            "kind": "LinkedField",
            "name": "UpdateDimensionFieldSuccess",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateGitHubDimensionFieldSuccess",
            "kind": "LinkedField",
            "name": "UpdateGitHubDimensionFieldSuccess",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MovePokerTemplateScaleValueSuccess",
            "kind": "LinkedField",
            "name": "MovePokerTemplateScaleValueSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TemplateScale",
                "kind": "LinkedField",
                "name": "scale",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TemplateScaleValueList_scale"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AcceptTeamInvitationPayload",
            "kind": "LinkedField",
            "name": "AcceptTeamInvitationPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DashNavListTeam"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddAgendaItemPayload",
            "kind": "LinkedField",
            "name": "AddAgendaItemPayload",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "useGotoStageId_meeting",
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "updateLocalStage_meeting",
                        "selections": [
                          (v1/*: any*/),
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      },
                      (v28/*: any*/),
                      (v15/*: any*/),
                      (v24/*: any*/),
                      (v29/*: any*/),
                      (v1/*: any*/),
                      (v31/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaItem",
                                "kind": "LinkedField",
                                "name": "agendaItem",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamMember",
                                    "kind": "LinkedField",
                                    "name": "teamMember",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AgendaItemsStage",
                            "abstractKey": null
                          },
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddAtlassianAuthPayload",
            "kind": "LinkedField",
            "name": "AddAtlassianAuthPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMemberIntegrations",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AtlassianIntegration",
                        "kind": "LinkedField",
                        "name": "atlassian",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AtlassianProviderRowAtlassianIntegration"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "useIsIntegratedAtlassianIntegration"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddReflectTemplatePayload",
            "kind": "LinkedField",
            "name": "AddReflectTemplatePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectTemplate",
                "kind": "LinkedField",
                "name": "reflectTemplate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TemplateSharing_template"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReflectTemplateDetailsTemplate"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityDetails_template"
                  },
                  (v1/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddReflectTemplatePromptPayload",
            "kind": "LinkedField",
            "name": "AddReflectTemplatePromptPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v1/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TemplatePromptItem_prompt"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TemplatePromptItem_prompts"
                  },
                  (v36/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddTeamPayload",
            "kind": "LinkedField",
            "name": "AddTeamPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NewTeamForm_teams"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingsDashActiveMeetings"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Team_team"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArchiveTeamPayload",
            "kind": "LinkedField",
            "name": "ArchiveTeamPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyTeamArchived",
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v8/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamArchived_notification"
                  }
                ],
                "storageKey": null
              },
              (v40/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          (v42/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EndCheckInSuccess",
            "kind": "LinkedField",
            "name": "EndCheckInSuccess",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v49/*: any*/),
              (v51/*: any*/),
              (v54/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndRetrospectiveSuccess",
            "kind": "LinkedField",
            "name": "EndRetrospectiveSuccess",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v28/*: any*/),
                  (v15/*: any*/),
                  (v44/*: any*/),
                  (v55/*: any*/),
                  (v45/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": (v58/*: any*/),
                    "concreteType": "RetroReflectionGroup",
                    "kind": "LinkedField",
                    "name": "reflectionGroups",
                    "plural": true,
                    "selections": [
                      (v59/*: any*/),
                      (v60/*: any*/)
                    ],
                    "storageKey": "reflectionGroups(sortBy:\"voteCount\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetroDiscussStage",
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "DiscussPhase",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetrospectiveMeetingSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                      (v61/*: any*/),
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v63/*: any*/),
              (v51/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndSprintPokerSuccess",
            "kind": "LinkedField",
            "name": "EndSprintPokerSuccess",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              (v64/*: any*/),
              (v63/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndTeamPromptSuccess",
            "kind": "LinkedField",
            "name": "EndTeamPromptSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v28/*: any*/),
                  (v65/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamPromptMeeting_meeting"
                  }
                ],
                "storageKey": null
              },
              (v49/*: any*/),
              (v51/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MoveReflectTemplatePromptPayload",
            "kind": "LinkedField",
            "name": "MoveReflectTemplatePromptPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NavigateMeetingPayload",
            "kind": "LinkedField",
            "name": "NavigateMeetingPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SelectMeetingDropdownItem_meeting"
                  },
                  (v1/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "localStage",
                        "plural": false,
                        "selections": (v38/*: any*/),
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "oldFacilitatorStage",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseCompletePayload",
                "kind": "LinkedField",
                "name": "phaseComplete",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReflectPhaseCompletePayload",
                    "kind": "LinkedField",
                    "name": "reflect",
                    "plural": false,
                    "selections": [
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetroReflectionGroup",
                        "kind": "LinkedField",
                        "name": "reflectionGroups",
                        "plural": true,
                        "selections": [
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupPhaseCompletePayload",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeeting",
                        "kind": "LinkedField",
                        "name": "meeting",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VotePhaseCompletePayload",
                    "kind": "LinkedField",
                    "name": "vote",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeeting",
                        "kind": "LinkedField",
                        "name": "meeting",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "unlockedStages",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v27/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromoteToTeamLeadPayload",
            "kind": "LinkedField",
            "name": "PromoteToTeamLeadPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "oldLeader",
                "plural": false,
                "selections": (v68/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "newLeader",
                "plural": false,
                "selections": (v68/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v70/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReflectTemplatePromptUpdateGroupColorPayload",
            "kind": "LinkedField",
            "name": "ReflectTemplatePromptUpdateGroupColorPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveAgendaItemPayload",
            "kind": "LinkedField",
            "name": "RemoveAgendaItemPayload",
            "plural": false,
            "selections": [
              (v71/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveOrgUserPayload",
            "kind": "LinkedField",
            "name": "RemoveOrgUserPayload",
            "plural": false,
            "selections": [
              (v72/*: any*/),
              (v73/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "activeMeetings",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      (v29/*: any*/),
                      (v74/*: any*/),
                      (v76/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveReflectTemplatePayload",
            "kind": "LinkedField",
            "name": "RemoveReflectTemplatePayload",
            "plural": false,
            "selections": [
              (v78/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeetingSettings",
                "kind": "LinkedField",
                "name": "retroMeetingSettings",
                "plural": false,
                "selections": (v81/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v82/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveTeamMemberPayload",
            "kind": "LinkedField",
            "name": "RemoveTeamMemberPayload",
            "plural": false,
            "selections": [
              (v83/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyKickedOut",
                "kind": "LinkedField",
                "name": "kickOutNotification",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v8/*: any*/),
                  (v40/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "KickedOut_notification"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "activeMeetings",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      (v29/*: any*/),
                      (v74/*: any*/),
                      (v76/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v84/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RenameMeetingSuccess",
            "kind": "LinkedField",
            "name": "RenameMeetingSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": (v85/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RenameMeetingTemplatePayload",
            "kind": "LinkedField",
            "name": "RenameMeetingTemplatePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meetingTemplate",
                "plural": false,
                "selections": (v85/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RenameReflectTemplatePromptPayload",
            "kind": "LinkedField",
            "name": "RenameReflectTemplatePromptPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v34/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SelectTemplatePayload",
            "kind": "LinkedField",
            "name": "SelectTemplatePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meetingSettings",
                "plural": false,
                "selections": [
                  (v86/*: any*/),
                  (v87/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v89/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SetMeetingSettingsPayload",
            "kind": "LinkedField",
            "name": "SetMeetingSettingsPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                  (v90/*: any*/),
                  (v91/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartCheckInSuccess",
            "kind": "LinkedField",
            "name": "StartCheckInSuccess",
            "plural": false,
            "selections": [
              (v92/*: any*/),
              (v96/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartRetrospectiveSuccess",
            "kind": "LinkedField",
            "name": "StartRetrospectiveSuccess",
            "plural": false,
            "selections": [
              (v97/*: any*/),
              (v96/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartSprintPokerSuccess",
            "kind": "LinkedField",
            "name": "StartSprintPokerSuccess",
            "plural": false,
            "selections": [
              (v98/*: any*/),
              (v96/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartTeamPromptSuccess",
            "kind": "LinkedField",
            "name": "StartTeamPromptSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v65/*: any*/)
                ],
                "storageKey": null
              },
              (v96/*: any*/)
            ],
            "storageKey": null
          },
          (v99/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OldUpdateCreditCardPayload",
            "kind": "LinkedField",
            "name": "OldUpdateCreditCardPayload",
            "plural": false,
            "selections": (v101/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "UpdateCreditCardPayload",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v101/*: any*/),
                "type": "UpdateCreditCardSuccess",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTeamNamePayload",
            "kind": "LinkedField",
            "name": "UpdateTeamNamePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": (v85/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTemplateCategorySuccess",
            "kind": "LinkedField",
            "name": "UpdateTemplateCategorySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v102/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateUserProfilePayload",
            "kind": "LinkedField",
            "name": "UpdateUserProfilePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMembers",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v95/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OldUpgradeToTeamTierPayload",
            "kind": "LinkedField",
            "name": "OldUpgradeToTeamTierPayload",
            "plural": false,
            "selections": (v104/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpgradeToTeamTierSuccess",
            "kind": "LinkedField",
            "name": "UpgradeToTeamTierSuccess",
            "plural": false,
            "selections": (v104/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateIntegrationProviderSuccess",
            "kind": "LinkedField",
            "name": "UpdateIntegrationProviderSuccess",
            "plural": false,
            "selections": (v107/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddIntegrationProviderSuccess",
            "kind": "LinkedField",
            "name": "AddIntegrationProviderSuccess",
            "plural": false,
            "selections": (v107/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TeamSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TeamSubscriptionPayload",
        "kind": "LinkedField",
        "name": "teamSubscription",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateDimensionFieldSuccess",
            "kind": "LinkedField",
            "name": "UpdateDimensionFieldSuccess",
            "plural": false,
            "selections": (v109/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateGitHubDimensionFieldSuccess",
            "kind": "LinkedField",
            "name": "UpdateGitHubDimensionFieldSuccess",
            "plural": false,
            "selections": (v109/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MovePokerTemplateScaleValueSuccess",
            "kind": "LinkedField",
            "name": "MovePokerTemplateScaleValueSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TemplateScale",
                "kind": "LinkedField",
                "name": "scale",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v111/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AcceptTeamInvitationPayload",
            "kind": "LinkedField",
            "name": "AcceptTeamInvitationPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v112/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v7/*: any*/),
                      (v113/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  (v100/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddAgendaItemPayload",
            "kind": "LinkedField",
            "name": "AddAgendaItemPayload",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  (v114/*: any*/),
                  (v1/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v108/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v108/*: any*/),
                          (v1/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v30/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgendaItem",
                                "kind": "LinkedField",
                                "name": "agendaItem",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v116/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AgendaItemsStage",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      (v117/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/),
                  (v15/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddAtlassianAuthPayload",
            "kind": "LinkedField",
            "name": "AddAtlassianAuthPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMemberIntegrations",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AtlassianIntegration",
                        "kind": "LinkedField",
                        "name": "atlassian",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accessToken",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isActive",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddReflectTemplatePayload",
            "kind": "LinkedField",
            "name": "AddReflectTemplatePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectTemplate",
                "kind": "LinkedField",
                "name": "reflectTemplate",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReflectPrompt",
                    "kind": "LinkedField",
                    "name": "prompts",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v21/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scope",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": (v118/*: any*/),
                            "storageKey": null
                          },
                          (v1/*: any*/),
                          (v119/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateScale",
                            "kind": "LinkedField",
                            "name": "scales",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v7/*: any*/),
                              (v111/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "editingScaleId",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastUsedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isFree",
                        "storageKey": null
                      },
                      (v102/*: any*/),
                      (v119/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "illustrationUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "viewerLowestScope",
                        "storageKey": null
                      },
                      (v108/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateDimension",
                            "kind": "LinkedField",
                            "name": "dimensions",
                            "plural": true,
                            "selections": [
                              (v21/*: any*/),
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateScale",
                                "kind": "LinkedField",
                                "name": "selectedScale",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v15/*: any*/),
                                  (v120/*: any*/),
                                  (v7/*: any*/),
                                  (v121/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "team",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TemplateScale",
                                    "kind": "LinkedField",
                                    "name": "scales",
                                    "plural": true,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v120/*: any*/),
                                      (v15/*: any*/),
                                      (v7/*: any*/),
                                      (v121/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PokerTemplate",
                        "abstractKey": null
                      }
                    ],
                    "type": "MeetingTemplate",
                    "abstractKey": "__isMeetingTemplate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddReflectTemplatePromptPayload",
            "kind": "LinkedField",
            "name": "AddReflectTemplatePromptPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v1/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddTeamPayload",
            "kind": "LinkedField",
            "name": "AddTeamPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "teamMembers",
                    "plural": true,
                    "selections": [
                      (v69/*: any*/),
                      (v122/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v127/*: any*/),
                  (v100/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v113/*: any*/),
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": true,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "teamId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": "teamName",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArchiveTeamPayload",
            "kind": "LinkedField",
            "name": "ArchiveTeamPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyTeamArchived",
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v8/*: any*/),
                  (v128/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "archivor",
                    "plural": false,
                    "selections": (v115/*: any*/),
                    "storageKey": null
                  },
                  (v129/*: any*/)
                ],
                "storageKey": null
              },
              (v132/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          (v42/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EndCheckInSuccess",
            "kind": "LinkedField",
            "name": "EndCheckInSuccess",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v133/*: any*/),
              (v134/*: any*/),
              (v54/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndRetrospectiveSuccess",
            "kind": "LinkedField",
            "name": "EndRetrospectiveSuccess",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v28/*: any*/),
                  (v15/*: any*/),
                  (v44/*: any*/),
                  (v55/*: any*/),
                  (v45/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": (v58/*: any*/),
                    "concreteType": "RetroReflectionGroup",
                    "kind": "LinkedField",
                    "name": "reflectionGroups",
                    "plural": true,
                    "selections": [
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": "reflectionGroups(sortBy:\"voteCount\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v108/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RetroDiscussStage",
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v59/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "DiscussPhase",
                        "abstractKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetrospectiveMeetingSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v135/*: any*/),
              (v134/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndSprintPokerSuccess",
            "kind": "LinkedField",
            "name": "EndSprintPokerSuccess",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              (v64/*: any*/),
              (v135/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EndTeamPromptSuccess",
            "kind": "LinkedField",
            "name": "EndTeamPromptSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v28/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingSeries",
                    "kind": "LinkedField",
                    "name": "meetingSeries",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v136/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamPromptMeeting",
                    "kind": "LinkedField",
                    "name": "prevMeeting",
                    "plural": false,
                    "selections": (v38/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamPromptMeeting",
                    "kind": "LinkedField",
                    "name": "nextMeeting",
                    "plural": false,
                    "selections": (v38/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": (v38/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v108/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v108/*: any*/),
                          (v1/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/),
                              (v116/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPromptResponse",
                                "kind": "LinkedField",
                                "name": "response",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v19/*: any*/),
                                  (v53/*: any*/),
                                  (v93/*: any*/),
                                  (v137/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TeamPromptResponseStage",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamPromptResponseStage",
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamMember",
                                "kind": "LinkedField",
                                "name": "teamMember",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v1/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPromptResponse",
                                "kind": "LinkedField",
                                "name": "response",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plaintextContent",
                                    "storageKey": null
                                  },
                                  (v93/*: any*/),
                                  (v16/*: any*/),
                                  (v19/*: any*/),
                                  (v53/*: any*/),
                                  (v137/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v15/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "meeting",
                                "plural": false,
                                "selections": [
                                  (v108/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v28/*: any*/),
                                      (v138/*: any*/)
                                    ],
                                    "type": "TeamPromptMeeting",
                                    "abstractKey": null
                                  },
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": (v139/*: any*/),
                                    "concreteType": "ThreadableConnection",
                                    "kind": "LinkedField",
                                    "name": "thread",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ThreadableEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v108/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "createdByUser",
                                                "plural": false,
                                                "selections": (v22/*: any*/),
                                                "storageKey": null
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cursor",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endCursor",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasNextPage",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "thread(first:1000)"
                                  },
                                  {
                                    "alias": null,
                                    "args": (v139/*: any*/),
                                    "filters": null,
                                    "handle": "connection",
                                    "key": "DiscussionThread_thread",
                                    "kind": "LinkedHandle",
                                    "name": "thread"
                                  },
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "TeamPromptResponsesPhase",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingPrompt",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v30/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v124/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "viewerMeetingMember",
                        "plural": false,
                        "selections": (v130/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMembers",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v69/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": [
                          (v108/*: any*/),
                          (v1/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v123/*: any*/),
                              (v88/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v116/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationUser",
                            "kind": "LinkedField",
                            "name": "viewerOrganizationUser",
                            "plural": false,
                            "selections": (v38/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          (v140/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "localPhase",
                            "plural": false,
                            "selections": [
                              (v108/*: any*/),
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": (v130/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showSidebar",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "NewMeeting",
                    "abstractKey": "__isNewMeeting"
                  },
                  (v138/*: any*/)
                ],
                "storageKey": null
              },
              (v133/*: any*/),
              (v134/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MoveReflectTemplatePromptPayload",
            "kind": "LinkedField",
            "name": "MoveReflectTemplatePromptPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v37/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NavigateMeetingPayload",
            "kind": "LinkedField",
            "name": "NavigateMeetingPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  (v114/*: any*/),
                  (v1/*: any*/),
                  (v7/*: any*/),
                  (v124/*: any*/),
                  (v125/*: any*/),
                  (v129/*: any*/),
                  (v24/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      (v140/*: any*/)
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "oldFacilitatorStage",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  (v1/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseCompletePayload",
                "kind": "LinkedField",
                "name": "phaseComplete",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReflectPhaseCompletePayload",
                    "kind": "LinkedField",
                    "name": "reflect",
                    "plural": false,
                    "selections": [
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetroReflectionGroup",
                        "kind": "LinkedField",
                        "name": "reflectionGroups",
                        "plural": true,
                        "selections": [
                          (v21/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GroupPhaseCompletePayload",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeeting",
                        "kind": "LinkedField",
                        "name": "meeting",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v108/*: any*/),
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": [
                                  (v108/*: any*/),
                                  (v1/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v30/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VotePhaseCompletePayload",
                    "kind": "LinkedField",
                    "name": "vote",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetrospectiveMeeting",
                        "kind": "LinkedField",
                        "name": "meeting",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v108/*: any*/),
                              (v1/*: any*/),
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "unlockedStages",
                "plural": true,
                "selections": [
                  (v108/*: any*/),
                  (v1/*: any*/),
                  (v27/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromoteToTeamLeadPayload",
            "kind": "LinkedField",
            "name": "PromoteToTeamLeadPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "oldLeader",
                "plural": false,
                "selections": (v141/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "newLeader",
                "plural": false,
                "selections": (v141/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v70/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReflectTemplatePromptUpdateGroupColorPayload",
            "kind": "LinkedField",
            "name": "ReflectTemplatePromptUpdateGroupColorPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveAgendaItemPayload",
            "kind": "LinkedField",
            "name": "RemoveAgendaItemPayload",
            "plural": false,
            "selections": [
              (v71/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  (v1/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "phases",
                    "plural": true,
                    "selections": [
                      (v108/*: any*/),
                      (v117/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UpdatesStage",
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v27/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UpdatesPhase",
                        "abstractKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveOrgUserPayload",
            "kind": "LinkedField",
            "name": "RemoveOrgUserPayload",
            "plural": false,
            "selections": [
              (v72/*: any*/),
              (v73/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v142/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveReflectTemplatePayload",
            "kind": "LinkedField",
            "name": "RemoveReflectTemplatePayload",
            "plural": false,
            "selections": [
              (v78/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RetrospectiveMeetingSettings",
                "kind": "LinkedField",
                "name": "retroMeetingSettings",
                "plural": false,
                "selections": [
                  (v79/*: any*/),
                  (v80/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v82/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveTeamMemberPayload",
            "kind": "LinkedField",
            "name": "RemoveTeamMemberPayload",
            "plural": false,
            "selections": [
              (v83/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyKickedOut",
                "kind": "LinkedField",
                "name": "kickOutNotification",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v8/*: any*/),
                  (v132/*: any*/),
                  (v128/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "evictor",
                    "plural": false,
                    "selections": (v115/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": (v142/*: any*/),
                "storageKey": null
              },
              (v84/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RenameMeetingSuccess",
            "kind": "LinkedField",
            "name": "RenameMeetingSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": (v143/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RenameMeetingTemplatePayload",
            "kind": "LinkedField",
            "name": "RenameMeetingTemplatePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meetingTemplate",
                "plural": false,
                "selections": (v143/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RenameReflectTemplatePromptPayload",
            "kind": "LinkedField",
            "name": "RenameReflectTemplatePromptPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReflectPrompt",
                "kind": "LinkedField",
                "name": "prompt",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SelectTemplatePayload",
            "kind": "LinkedField",
            "name": "SelectTemplatePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meetingSettings",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  (v86/*: any*/),
                  (v87/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v89/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SetMeetingSettingsPayload",
            "kind": "LinkedField",
            "name": "SetMeetingSettingsPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  (v90/*: any*/),
                  (v91/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartCheckInSuccess",
            "kind": "LinkedField",
            "name": "StartCheckInSuccess",
            "plural": false,
            "selections": [
              (v92/*: any*/),
              (v144/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartRetrospectiveSuccess",
            "kind": "LinkedField",
            "name": "StartRetrospectiveSuccess",
            "plural": false,
            "selections": [
              (v97/*: any*/),
              (v144/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartSprintPokerSuccess",
            "kind": "LinkedField",
            "name": "StartSprintPokerSuccess",
            "plural": false,
            "selections": [
              (v98/*: any*/),
              (v144/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StartTeamPromptSuccess",
            "kind": "LinkedField",
            "name": "StartTeamPromptSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPromptMeeting",
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingSeries",
                    "kind": "LinkedField",
                    "name": "meetingSeries",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v136/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v144/*: any*/)
            ],
            "storageKey": null
          },
          (v99/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OldUpdateCreditCardPayload",
            "kind": "LinkedField",
            "name": "OldUpdateCreditCardPayload",
            "plural": false,
            "selections": (v145/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "UpdateCreditCardPayload",
            "plural": false,
            "selections": [
              (v108/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v145/*: any*/),
                "type": "UpdateCreditCardSuccess",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTeamNamePayload",
            "kind": "LinkedField",
            "name": "UpdateTeamNamePayload",
            "plural": false,
            "selections": [
              (v129/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTemplateCategorySuccess",
            "kind": "LinkedField",
            "name": "UpdateTemplateCategorySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v108/*: any*/),
                  (v102/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateUserProfilePayload",
            "kind": "LinkedField",
            "name": "UpdateUserProfilePayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMembers",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v126/*: any*/),
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OldUpgradeToTeamTierPayload",
            "kind": "LinkedField",
            "name": "OldUpgradeToTeamTierPayload",
            "plural": false,
            "selections": (v146/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpgradeToTeamTierSuccess",
            "kind": "LinkedField",
            "name": "UpgradeToTeamTierSuccess",
            "plural": false,
            "selections": (v146/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateIntegrationProviderSuccess",
            "kind": "LinkedField",
            "name": "UpdateIntegrationProviderSuccess",
            "plural": false,
            "selections": (v147/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddIntegrationProviderSuccess",
            "kind": "LinkedField",
            "name": "AddIntegrationProviderSuccess",
            "plural": false,
            "selections": (v147/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "s_86U7p-GzmXX92fQIhOIcaA",
    "metadata": {},
    "name": "TeamSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node ).hash = "c33790b708214580822d1ba49b9e0029";

export default node;
